/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseWorkPackageDto } from '../../models/base-work-package-dto';
import { CreateWorkPackageFromTemplateRequest } from '../../models/create-work-package-from-template-request';

export interface CreateWorkPackageFromTemplate$Params {
      body: CreateWorkPackageFromTemplateRequest
}

export function createWorkPackageFromTemplate(http: HttpClient, rootUrl: string, params: CreateWorkPackageFromTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseWorkPackageDto>> {
  const rb = new RequestBuilder(rootUrl, createWorkPackageFromTemplate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseWorkPackageDto>;
    })
  );
}

createWorkPackageFromTemplate.PATH = '/v0/workPackages/from-template';
